import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useClient } from './useClient';
import {
  CompleteInstallationRequest,
  CompleteInstallationResponse,
} from '@hud/slack-dtos/api';
import { SLACK_STATUS_KEY } from './useSlackStatus';
import { CHANNELS_KEY } from './useChannels';
import useAnalytics from './useAnalytics';

export default function useCompleteSlackInstallationMutation() {
  const { client } = useClient();
  const queryClient = useQueryClient();
  const analytics = useAnalytics();

  return useMutation({
    mutationFn: async (code: string) => {
      const response = await client.post<CompleteInstallationResponse>(
        '/slack/complete-installation',
        CompleteInstallationRequest.parse({ code, www: origin.includes('www.') }),
      );
      return CompleteInstallationResponse.parse(response.data);
    },
    onSuccess: () => {
      analytics.capture('slack_app_connected', {});
      // Invalidate the slack status query to refetch the updated status
      queryClient.invalidateQueries({ queryKey: [SLACK_STATUS_KEY] });
      queryClient.invalidateQueries({ queryKey: [CHANNELS_KEY] });
    },
    onError: () => {
      analytics.capture('slack_app_connection_failed', {});
    },
  });
}
